import React from 'react';
import { DrawerOverlay } from './DrawerOverlay';

interface Props {
    heading: React.ReactNode;
    children: React.ReactNode;
    showing: boolean;
    onDismiss?: () => void;
}

const ConfirmationModal = ({ heading, showing, onDismiss, children }: Props) => (
    <DrawerOverlay showing={showing} onClose={onDismiss} variations={['center']}>
        <div className="heading--with-divider heading--h3">{heading}</div>
        {children}
    </DrawerOverlay>
);

export default ConfirmationModal;
